<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="1">SERVIÇOS</th>
      </tr>
      <tr v-for="(item, index) in selectedServices" :key="index">
        <td class="pl-3">
          <b>Serviço</b>:
          {{ getFormattedItemName(item) }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.SERVICES"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.SERVICES"
    ></div>
  </vx-card>
</template>

<script>
import { getFormattedItemName } from '../../../services/contract';
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractServices',
  props: {
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
      getFormattedItemName,
    };
  },
  computed: {
    selectedServices() {
      return functions.getEndorsementContractedProductsWithDetails(
        this.quotationData.coverage_contracted,
        this.quotationData.all_coverages,
        true,
      );
    },
  },
};
</script>
